<template>
  <div id="DeliveryCalc" class="mdl-grid mdl-width-area mt-10 mb-10 justify-center">
    <div class="w-full" v-if="!firstLoad">
      <h2 class="text-titlesm md:text-titlemd tb:text-titlexl font-semibold">
        {{ lang.title }}
      </h2>
      <div>
        <span class="text-lighter"> {{ lang.country }}: </span>
        <span class="font-medium">{{ country.name }}</span>
      </div>
      <form
        class="flex items-end w-full pt-6 pb-8 mb-4 gap-3"
        v-on:submit.prevent
      >
        <div class="w-full">
          <label class="mt-4" for="city">
            {{ lang.yourCity }}
          </label>
          <GmapAutocomplete
            class="border border-gray-2 w-full p-3 mt-3"
            id="city"
            v-if="country.code"
            placeholder=""
            :componentRestrictions="{ country: country.code }"
            :types="['(regions)']"
            @place_changed="apiCallback"
          />
        </div>
      </form>
    </div>
    <Loader v-if="loading" :firstLoad="firstLoad" :type="2" :size="2" />
    <Error v-if="error" :lang="lang" />
    <DeliveryInfo
      v-if="!error && !loading"
      :deliveryItems="deliveryItems"
      :pickup="iPickup"
      :lang="lang"
    />
    <Info :lang="lang" :country="country.code" />
  </div>
</template>

<script>
import DeliveryInfo from "./components/DeliveryInfo.vue"
import Info from "./components/Info"
import Loader from "@/components/Loader"
import Error from "@/components/Error"
import {crimeaCities} from './assets/crimeaCities.js'

export default {
  name: "DeliveryCalc",
  components: {
    DeliveryInfo,
    Loader,
    Info,
    Error,
  },
  data() {
    return {
      country: Array,
      deliveryItems: [],
      city: "",
      area: "",
      loading: true,
      lang: Array,
      firstLoad: true,
      iPickup: false,
      error: false,
      accentMap: 
      {
        а́: 'а',
        е́: 'е',
        ё́: 'ё',
        и́: 'и',
        о́: 'о',
        у́: 'у',
        ы́: 'ы',
        э́: 'э',
        ю́: 'ю',
        я́: 'я',
        А́: 'А',
        Е́: 'Е',
        Ё́: 'Ё',
        И́: 'И',
        О́: 'О',
        У́: 'У',
        Ы́: 'Ы',
        Э́: 'Э',
        Ю́: 'Ю',
        Я́: 'Я',
      },
      
    }
  },
  async beforeMount() {
    await this.init()
  },
  methods: {
    async init() {
      const response = await this.$axios.get(
        `/ajax/calcDelivery/initArray.php`
      );
      if (response) {
        this.firstLoad = false
        this.loading = false
      }
      (this.country = response.data.location), (this.lang = response.data.lang);
    },

    async apiCallback(place) {
      const initialValues = place.address_components
      const reversedValues = initialValues.reverse();
      let hasAreaField = reversedValues.find((field) => { 
        return field.types.includes('administrative_area_level_1') || (field.types.includes('administrative_area_level_2') &&
          field.types.includes('political'))
      })

      this.area = hasAreaField
        ? hasAreaField.long_name
        : null

      let hasCityField = false;
      hasCityField = initialValues.find((element) =>
        element.types.includes('postal_town')
      );

      if (!hasCityField) {
        hasCityField = initialValues.find((element) =>
          element.types.includes('locality')
        )
      }

      this.city = hasCityField
        ? hasCityField.long_name
        : null
      
      this.loading = true
      this.error = false

      if ((!this.area || this.area === this.city) && crimeaCities.includes(this.city)) {
        this.area = 'Крым Республика'
      }

      this.area = this.removeAccents(this.area, this.accentMap)

      const response = await this.$axios.get(
        `/sv-api/delivery?AREA=${this.area}&CITY=${this.city}&COUNTRY=${this.country.code}`
      );
      if (response.data.result) {
        this.deliveryItems = response.data.result
        this.error = false
      } else {
        this.error = true
        this.loading = false
      }

      let arr = this.deliveryItems;
      let words = [this.lang.days1, this.lang.days2, this.lang.days3]

      let idPickup = false

      arr.forEach(function(item) {
        let arrItem = item.ITEMS
        item.ITEMSCOUNT = item.ITEMS.length
        arrItem.forEach(function(it) {
          if(it.ID == "I_PICKUP") {
            item.ITEMSCOUNT = item.ITEMSCOUNT - 1
            idPickup = true
          }
          if (it.ID != "I_COURIER_1DAY") {
            if (it.PRICE_RULE) {
              if (it.PRICE_RULE.indexOf("=") != -1) {
                let arRule = it.PRICE_RULE.split(",")
                let conditionFirst = arRule[0].split("=")[1]
                let priceFirst = arRule[0].split("=")[0]
                it["condition"] = true
                it["conditionFirst"] = conditionFirst
                it["priceFirst"] = priceFirst
                it["priceSecond"] = arRule[1]
              } else {
                it["condition"] = false
              }
            } else if (it.PRICE == 0) {
              it["free"] = true
            }

            let transit = it.TRANSIT
            let arrTransit = transit.split("-")
            let value = arrTransit[arrTransit.length - 1]
            let cases = [2, 0, 1, 1, 1, 2]
            let word =
              words[
                value % 100 > 4 && value % 100 < 20
                  ? 2
                  : cases[value % 10 < 5 ? value % 10 : 5]
              ];
            it.TRANSIT = transit + " " + word
          }
        });
      });

      if (idPickup) {
        this.iPickup = true
      }

      this.loading = false
    },
    removeAccents(inputString, accentMap) {

      const accents = Object.keys(accentMap).join('|')
      const accentRegex = new RegExp(accents, 'g')

      return inputString.replace(accentRegex, (match) => accentMap[match])
    }
  },
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");

#DeliveryCalc {
  font-family: Rubik, Arial, sans-serif;
  color: #333f48;
  /*margin-top: -100px;*/
}

#DeliveryCalc > div {
  max-width: 1072px;
}

#DeliveryCalc > div.firstLoad {
  max-width: 100% !important; 
  width: 100%;
  min-height: 200px;
}

.pac-logo:after {
  display: none !important;
}

.pac-container,
.pac-container span {
  font-family: Rubik, Arial, sans-serif;
}
</style>
